export const   checkIdExists = (arrayOfObjects, searchId) => {
    // Using Array.some() to check if any object in the array has the specified ID
    return arrayOfObjects.some(obj => obj.id === searchId);
  };